import { useEffect, useState } from "react";
import { useDealer } from "../../../../../../tools/api";
import { Col, Row, Table } from "antd";
import { complexDigitToman, convertToJalaliWithTime, formatTime } from "../../../../../../tools/tools";
import { NotFound } from "../../../../../../sources/svg/svg";
import Loading from "../../../../../auxiliary/loader/loading";

const Balance = ({ purchase }) => {
	const { queryBalance, queryActivatedProductsMSISDN } = useDealer();
	console.log(purchase);
	const [balanceState, setBalance] = useState({
		orginalCredit: 0,
		usage: 0,
		packages: [],
		isLoading: false,
		type: purchase?.inT_MSISDNSimcardType || 0,
	});

	useEffect(() => {
		const initial = async () => {
			const respnseBalance = await queryBalance(purchase?.inT_MSISDN);
			if (respnseBalance)
				setBalance((bl) => ({ ...bl, orginalCredit: respnseBalance?.charginglimitvalueorig, usage: respnseBalance?.charginglimitvalue }));

			CartableListServ();
		};
		initial();
	}, []);

	const CartableListServ = async () => {
		setBalance((bl) => ({ ...bl, isLoading: true }));
		let response = await queryActivatedProductsMSISDN(purchase?.inT_MSISDN);
		if (response) {
			setBalance((bl) => ({ ...bl, packages: response }));
		}
		setBalance((bl) => ({ ...bl, isLoading: false }));
	};

	const switchShowCalcData = (type, value) => {
		if (type === "data") {
			return (
				<span>
					<span dir="ltr">{(value / 1024).toFixed(2)}</span> GB
				</span>
			);
		}
		if (type === "voice") {
			return (
				<>
					<span>
						<span dir="ltr">{value}</span> دقیقه
					</span>
				</>
			);
		}
		if (type === "sms") {
			return (
				<>
					<span>
						<span dir="ltr">{value}</span> عدد
					</span>
				</>
			);
		}
	};
	const switchShowPackage = (type, packageName, isCombo = false) => {
		if (type === "data") {
			return (
				<span>
					{isCombo && <>ترکیبی - </>}
					{packageName?.split("+")?.find((item) => !item.includes("مکالمه", "پیامک"))}
				</span>
			);
		} else if (type === "voice") {
			return (
				<span>
					{isCombo && <>ترکیبی - </>} {packageName?.split("+")?.find((item) => item.includes("مکالمه"))}
				</span>
			);
		} else if (type === "sms") {
			return (
				<span>
					{isCombo && <>ترکیبی - </>}
					{packageName?.split("+")?.find((item) => item.includes("پیامک"))}
				</span>
			);
		} else {
			return "";
		}
	};

	return (
		<>
			<br />
			<br />
			<div className="purchase_detail_360">
				<div className="page_title">اعتبار اصلی</div>
				<div className="page_body">
					{balanceState?.type === 1 ? (
						<>
							<Row>
								<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
									<div className="label">میزان مصرف:</div>
									<div className="value">
										<span dir="ltr">{complexDigitToman(balanceState?.orginalCredit - balanceState?.usage) || "-"}</span> تومان
									</div>
								</Col>
								<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
									<div className="label">سقف اعتبار:</div>
									<div className="value">
										<span dir="ltr">{complexDigitToman(balanceState?.orginalCredit) || "-"}</span> نومان
									</div>
								</Col>
							</Row>
							<Row>
								<Col xxl={24}>
									<p className="noteMsg">جهت پرداخت بدهی خود می‌توانید از طریق سایت آپتل اقدام نمایید</p>
								</Col>
							</Row>
						</>
					) : (
						<>
							<Row>
								<Col xxl={4} xl={4} lg={4} md={8} sm={12} xs={24}>
									<div className="label">باقیمانده اعتبار:</div>
									<div className="value">
										<span dir="ltr">{complexDigitToman(balanceState?.usage) || "-"}</span> تومان
									</div>
								</Col>
							</Row>
						</>
					)}
				</div>
			</div>
			<div className="purchase_detail_360">
				<div className="page_title">بسته</div>
				<div className="holder-table" style={{ marginTop: "3rem" }}>
					<Table
						className="tbl-normal"
						columns={[
							{ title: "نام بسته", dataIndex: "packagename", key: "packagename", width: 150 },
							{ title: "تاریخ فعالسازی", dataIndex: "activedate", key: "activedate", width: 150 },
							{ title: "تاریخ انقضا", dataIndex: "expiredate", key: "expiredate", width: 150 },
							{ title: "حجم مصرف شده", dataIndex: "usage", key: "usage", width: 150 },
							{ title: "حجم کل", dataIndex: "balance", key: "balance", width: 150 },
						]}
						locale={{
							emptyText: (
								<>
									<NotFound text={"رکوردی یافت نشد."} />
								</>
							),
						}}
						pagination={{
							showSizeChanger: false,
							position: [""],
						}}
						dataSource={balanceState?.packages.map((item, key) => ({
							key: key,
							packagename: switchShowPackage(
								item.category,
								item.extraPackagePurchase?.productName || item?.productInfo?.stR_PackageName,
								item.productInfo?.inT_PackageType === 2,
							),
							activedate: (
								<span>
									{convertToJalaliWithTime(item.startDate)} - {formatTime(new Date(item.startDate))}
								</span>
							),
							expiredate: (
								<span>
									{convertToJalaliWithTime(item.endDate)} - {formatTime(new Date(item.endDate))}
								</span>
							),
							usage: switchShowCalcData(item.category, item.usageValue),
							balance: switchShowCalcData(item.category, item.originValue),
						}))}
					/>
				</div>
			</div>
			<Loading isOpen={balanceState?.isLoading} />
		</>
	);
};

export default Balance;
